export default __webpack_public_path__ + "static/media/miguel-lopes-28.3c171ecb.mp4";